/**
 * Patch for country names that come back from the API with their accented
 * characters lost (e.g. 'Cura?ao', 'Saint Barth?lemy'). Keyed by ISO code so
 * the lookup does not depend on how the bad name was mangled.
 */
const COUNTRY_NAME_OVERRIDES: { [isoCode: string]: string } = {
  CW: 'Curaçao',
  CUW: 'Curaçao',
  BL: 'Saint Barthélemy',
  BLM: 'Saint Barthélemy',
};

export function fixCountryNames(countries: any[]): any[] {
  if (!countries) {
    return countries;
  }

  countries.forEach((country: any) => {
    const name =
      COUNTRY_NAME_OVERRIDES[country?.country] ??
      COUNTRY_NAME_OVERRIDES[country?.alpha3IsoCode];

    if (name) {
      country.countryName = name;
    }
  });

  return countries;
}
